export const SALARY_DUE_DAY_OPTIONS = [
  ...Array.from({ length: 30 }, (_, index) => ({
    value: String(index + 1),
    label: `Day ${index + 1}`,
  })),
  { value: '31', label: 'Last day of month' },
];

export const salaryDueDayLabel = (value) => (
  String(value) === '31' ? 'Last day of month' : `Day ${value || '-'}`
);
